import configReducers from "./config";
import e2eeReducers from "./e2ee";
import entitiesReducers from "./entities";
import extrasReducers from "./extras";
import sessionReducers from "./session";
import uiReducers from "./ui";

export default {
  ...configReducers,
  ...e2eeReducers,
  ...entitiesReducers,
  ...extrasReducers,
  ...sessionReducers,
  ...uiReducers,
};
